var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.70457 8.84019L1.21934 6.35496C0.940018 6.07564 0.488809 6.07564 0.20949 6.35496C-0.0698299 6.63428 -0.0698299 7.08549 0.20949 7.36481L3.20322 10.3585C3.48254 10.6379 3.93375 10.6379 4.21307 10.3585L11.7905 2.78111C12.0698 2.50179 12.0698 2.05058 11.7905 1.77126C11.5112 1.49194 11.06 1.49194 10.7807 1.77126L3.70457 8.84019Z",
    fill: "#00762A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.f3f9b3a517c0a72efd2b54b8c7a36295.svg";
export { ForwardRef as ReactComponent };